// 编译html代码
DYC.filter('html', function($sce) {
    return function(text) {
        return $sce.trustAsHtml(text);
    };
});
// 过滤html代码
DYC.filter('text', function($sce) {
    return function(text) {
        return text.replace(/<\/?[^>]*>/g, '');
    };
});


// WEBPACK FOOTER //
// ./src/common/filter/html.js